import { AuthState } from './types';
import actions from './actions';
import { createReducer } from '@reduxjs/toolkit';
import AuthService from '../AuthService';

let { user, isLoggedIn } = AuthService.checkToken();

export const initialState: AuthState = {
  loggedIn: isLoggedIn,
  loggingIn: false,
  error: null,
  user
}

const authReducer = createReducer(initialState, (builder =>
  builder
    .addCase(actions.logout, () => {
      AuthService.logout();
      return { ...initialState, loggedIn: false, user: undefined };
    })
    .addCase(actions.login.pending, (state) => {
      return { ...state, loggingIn: true, user: undefined, error: null }
    })
    .addCase(actions.login.fulfilled, (state, action) => {
      return { ...state, loggedIn: true, user: action.payload.user, loggingIn: false }
    })
    .addCase(actions.login.rejected, (state, action) => {
      return { ...state, loggedIn: false, user: undefined, loggingIn: false, error: action.error }
    })
));

export default authReducer;